<template>
  <div class="curse">
    <div class="content">
      <!-- <van-tabs v-show="prpoDivStatus" v-model="active" :class="isNotApp ? 'top':'top1'" title-active-color="#EF2D2E" @click="changeIndex">
      <van-tab v-for="(item,index) in currentTitle" :key="index" :title="item.title" :name="item.id">
        
      </van-tab>
    </van-tabs> -->
      <div v-show="showNav" class="classifyBox">
        <div ref="onedivs" class="classify">
          <span class="title">类别：</span>
          <span class="item" :class="tabindex==item.id?'active':''" v-for="(item,index) in currentTitle"  @click="changeIndex(item.id)" :key="index">{{item.title}}</span>
          <img class="screen" src="@/assets/screen.png" alt="" @click="screenChange()">
        </div>
      </div>
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getMoreDatas">
          <!-- <div style="height:44px;"></div> -->
          <div v-for="(item,index) in datalist" :key="index" class="listsBox" @click="goDetail(item.lesson_id)">
            <div class="leftBox">
              <div v-show="item.tag" class="tag">
                {{ item.tag }}
              </div>
              <img class="thumb" :src="item.thumb + img_base" alt>
            </div>
            <div class="rightCxt">
              <div class="lessonName">
                <p>{{ item.lesson_name }}</p>
              </div>
              <div class="infoNum">
                <img class="student_icon" src="@/assets/img/team.png" alt="">
                <span class="student_counts">{{ showStudents(item.student_count) }}人学习</span>
                <img class="rate_icon" src="@/assets/img/haoping.png" alt="">
                <span class="rate_num">{{ parseInt(item.comment_rate) }}%好评</span>
              </div>
              <div class="lessonPrice">
                <span v-if="!(code_type && code_type ==1)">￥{{ item.price.toFixed(2) }}</span>
              </div>
            </div>
          </div>
        </van-list>
    </div>
    <van-popup v-model="screenShow" position="right" :style="{ width: '327px' ,height: '100%'}">
        <div class="fl">
          <div v-for="(item,index) in tag_arr" :key="index" class="screen-box">
            <div class="screen-title">
              <p class="title-left">{{ item.name }}</p>
              <p class="title-right">
                <!-- <span class="tabs-span">
                  <span v-if="item.ab&&item.ab[0]">{{ item.ab[0].name }}</span>
                  <span v-if="item.ab&&item.ab[1]">{{ item.ab[1].name }}</span>
                  <span v-show="item.ab && item.ab.length>2">...</span>
                </span> -->
                <img v-show="!item.show" src="@/assets/jt.png" alt="" @click="fold(item)">
                <img v-show="item.show" style="transform: rotate(180deg);" src="@/assets/jt.png" alt="" @click="fold(item)">
              </p>
            </div>
            <div v-show="!item.show" class="screen-tabs">
              <span v-for="(li,i) in item.list" :key="i" :class="li.id === tag_id ?'active':''" @click="selecttag(li,item)">{{ li.name }}</span>
            </div>
          </div>
        </div>
        <div class="bottomW"></div>
        <div class="btns">
          <!-- <van-button class="cz" round type="info" @click="reset">重置</van-button> -->
          <!-- （{{ howMony ? front_tags.length:tagsR.length }}个参数） -->
          <van-button class="qd" round type="info" @click="tagScreen">确定</van-button>
        </div>
      </van-popup>
      <!-- <div class="tabsBox">
        <p v-for="(i,index) in front_tags" :key="index" class="tabs_int">
          <span>{{ i.name }}<span style="margin-left: 14px" @click="delscreen(i)">x</span></span>
        </p>
      </div> -->
  </div>
</template>
<script>
// import { getCategoryLesson } from '@/api/edu.js'
import { getLessonList,getTagsList } from '@/api/lesson.js'
import '@/assets/fg.css'
import tool from '@/utils/tools.js'
import Cookies from 'js-cookie'
import WechatState from '@/utils/isWechatState.js'

export default {
  props: {
    msg: {
      type: String,
      default: ''
    },
    isNotApp: {
      type: Boolean,
      default: true
    },
    prpoDivStatus: {
      type: Boolean,
      default: true
    },
    downloadShow: {
      type: Boolean,
      default: false
    },
    showNav:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      img_base: '?x-oss-process=image/resize,m_fill,w_424,h_320',
      loading: false,
      finished: false,
      isShow: true,
      active: 2,
      tabindex: 0,
      total: 0,
      limit: 10,
      page: 1,
      datalist: [],
      currentIndex: 0,
      currentTitle: [
        { id: 0, title:'全部' },
        { id: 2, title: '训练营' },
        { id: 1, title: '精品课' },
        { id: 3, title: '公开课' }
      ],
      code_type: '',
      tag_arr:[],//标签列表
      screenShow: false, // 标签筛选
      tag_id : ''
    }
  },
  watch: {
    msg(newValue, oldValue) {
      console.log('监听到变化')
      this.getTagData()
      this.beforeOnLoad()
    },
    // downloadShow() {
    //   var noy = document.getElementsByClassName('van-tabs__wrap')[0]
    //   if (!tool.isInApp()) {
    //     if (this.downloadShow) {
    //       noy.style = 'top: auto'
    //     } else {
    //       noy.style = 'margin-top: -50px'
    //     }
    //   }
    // }
  },
  created() {
    // if(!Cookies.get('webSpecialty_id')){
    //   this.showSort = '1'
    // }
    this.getCurrentPage()

    this.beforeOnLoad()
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.getTagData()
  },
  destroyed() {
    document.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    fold(item) {
      console.log(item, 'item')
      if (item.show) {
        this.$set(item, 'show', false)
      } else {
        this.$set(item, 'show', true)
      }
    },
    // 筛选弹框显示
    screenChange() {
      this.screenShow = true
      this.howMony = true
    },
    // 标签检索
    selecttag(li, item) {
      this.tag_id = li.id
    },
    // 确认
    tagScreen(){
      this.tabindex = -1
      this.beforeOnLoad()
      this.screenShow = false
    },
    getTagData(){
      var info={
        category_id:this.msg
      }
      getTagsList(info).then((res)=>{
        if(res.errNo==0){
          this.tag_arr = res.result
        }
      })
    },
    handleScroll() {
      // 获取滚动时的高度
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if(this.$refs.onedivs){
        if (scrollTop > 60) {
        // 滚动大于60的时候要做的操作
          this.$refs.onedivs.style.position = 'fixed'
          this.$refs.onedivs.style.top = '0'
        } else {
          this.$refs.onedivs.style.position = 'static'
          this.$refs.onedivs.style.top = '0'
        }
      }
      
    },
    beforeOnLoad() {
      // 注意顺序
      this.datalist = []
      this.finished = false
      this.page = this.getCurrentPage()
      this.onLoad()
    },
    onLoad() {
      this.loading = true
      this.page = this.getCurrentPage()
      console.log('page is ' + this.page)
      const params = {
        pageNum: this.page,
        pageSize: this.limit,
        type: this.tabindex==-1?0:this.tabindex,
        tag_id: this.tag_id,
        category_id: this.msg
        // agent: 'wap'
      }
      getLessonList(params).then(res => {
        this.loading = false
        const result = res.result ? res.result : {}
        const list = result.list ? result.list : []
        this.code_type = result.code_type || 0
        this.total = result.count
        if (this.page === 1) {
          this.datalist = list
        } else {
          this.datalist = this.datalist.concat(list)
        }
        // 是否 有值显示
        if (this.datalist.length > 0) {
          this.isShow = true
        } else {
          this.isShow = false
        }
        // 是否结束
        if (list.length < this.limit) {
          this.finished = true
          console.log('没有更多了')
        } else {
          this.finished = false
        }
      })
    },
    getMoreDatas() {
      this.onLoad()
    },
    getCurrentPage() {
      const count = this.datalist.length
      const limit = this.limit
      const page = Math.ceil((count / limit)) + 1 // 默认1
      return page
    },
    goDetail(id) {
      // const mplogin = WechatState.checkWechatMPLogin()
      // if (!mplogin) return

      // 跳转课程详情页
      if (tool.isInApp()) {
        const url = window.location.href + 'd/' + id + '.html'
        console.log(url, 'url')
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_openLesson.postMessage(url)
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_openLesson'
            , url
            , function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        this.$router.push({
          path: '/home',
          query: {
            lesson_id: id
          }
        })
      }
    },
    changeIndex(name) {
      if(name==0){
        this.tag_id=''
      }
      this.tabindex = name
      this.beforeOnLoad()
    },
    showStudents(num) {
      if (num > 10000) {
        const value = parseFloat(num / 10000.0).toFixed(1)
        const str = String(value) + 'w'
        return str
      } else {
        return num
      }
    }
  }
}
</script>
<style scoped lang='scss'>
/deep/ .van-tabs__wrap {
  position: fixed;
  width: 100%;
  z-index: 999;
}
.curse {
  width: 100%;
  .top {
    margin-top: 86px;
    padding-bottom: 100px;
  }
  .top1 {
    margin-top: 0px;
  }
}
.content{
  padding-top: 80px;
  padding-bottom: 100px;
}
.classifyBox{
  height: 82px;
}
.classify{
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  z-index:1000;
  padding: 20px;
  font-size: 32px;
  position: relative;
  .item{
    margin: 0 15px;
  }
  .active{
    color:#ee2e2e;
  }
  .screen{
    position: absolute;
    right: 24px;
    width: 40px;
  }
}
// vant组件库样式修改
.van-tabs /deep/ .van-tabs__wrap {
  border-bottom: 1px solid #eee;
  margin-bottom: 10 0 13px auto;
}
.van-pull-refresh {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.van-icon /deep/ .van-icon::before {
  margin-right: 11px;
}
/deep/.van-tabs__line {
  border-radius: 0;
}
/deep/.van-tab .van-tab__text {
  font-size: 28px;
  color: #333;
  padding-top: 6px;
}
/deep/.van-tab--active .van-tab__text {
  font-size: 28px;
  color: #ee2e2e;
}
.listsBox {
  margin: 25px 20px 0px 20px;
  width: calc(100% - 40px);
  display: flex;
  flex-direction: row;
  background-color: #fff;
  border-bottom: 1px solid #eee;
}
.leftBox {
  width: 240px;
  display: flex;
  // flex-direction: column;
  .thumb {
    width: 240px;
    height: 155px;
    border-radius: 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .tag {
    position: absolute;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 10px 0px 10px 0;
    font-size: 24px;
    color: #866335;
    background-image: linear-gradient(to right, #fceacc, #f6d19d);
  }
}
.rightCxt {
  margin-left: 15px;
  width: calc(100% - 255px);
  // display: flex;
  // flex-direction: column;
  .lessonName {
    font-size: 30px;
    color: #333;
    min-height: 60px;
    line-height: 38px;
    word-break: break-all;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .infoNum {
    margin-top: 10px;
    display: flex;
    align-items: center;
    .student_icon {
      width: 30px;
      height: 24px;
    }
    .student_counts {
      margin-left: 8px;
      color: #999;
      font-size: 24px;
    }
    .rate_icon {
      margin-left: 20px;
      width: 26px;
      height: 30px;
    }
    .rate_num {
      margin-left: 8px;
      color: #999;
      font-size: 24px;
    }
  }
  .lessonPrice {
    margin-top: 10px;
    margin-bottom: 25px;
    color: #ee2e2e;
    font-size: 28px;
  }
}
.fl{
  padding: 86px 30px 0 20px;
  .screen-box{
    .screen-title{
      display: flex;
      justify-content: space-between;
      height: 88px;
      align-items: center;
      margin-bottom: 10px;
      .title-left{
        font-family: PingFangSC-Medium;
        font-size: 28px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 500;
        flex-shrink: 0;
      }
      .title-right{
        display: flex;
        align-items: center;
        .tabs-span{
          width: 400px;
          text-align: right;
          color: #EE2E2E;
          overflow: hidden; /*必须结合的属性,当内容溢出元素框时发生的事情*/
          text-overflow: ellipsis; /*可以用来多行文本的情况下，用省略号“…”隐藏超出范围的文本 。*/
          display: -webkit-box; /*必须结合的属性 ，将对象作为弹性伸缩盒子模型显示 。*/
          -webkit-line-clamp: 1; /*用来限制在一个块元素显示的文本的行数。*/
          -webkit-box-orient: vertical; /*必须结合的属性 ，设置或检索伸缩盒对象的子元素的排列方式 。*/
          span{
            font-family: PingFangSC-Medium;
            font-size: 24px;
            color: #EE2E2E;
            letter-spacing: 0;
            text-align: right;
            font-weight: 500;
            margin-right: 20px;
          }
        }
        img{
          width: 40px;
        }
      }
    }
    .screen-tabs{
      display: flex;
      flex-flow: wrap;
      span{
        height: 56px;
        line-height: 56px;
        padding: 0 32px;
        background: #F7F7F7;
        border-radius: 40px;
        margin: 0 30px 30px 0;
        border: 2px solid #F7F7F7;
      }
      .active{
        background: #FFEFEF;
        border: 2px solid rgba(238,46,46,1);
      }
    }
  }
}
.bottomW{
  position: sticky;
  width: 100%;
  height: 90px;
  bottom: 0;
  background: #fff;
}
.btns{
  display: flex;
  padding: 0 30px 0 20px;
  justify-content: space-between;
  position: sticky;
  bottom: 66px;
  background: #fff;
  .cz{
    width: 200px;
    height: 80px;
    color: #ee2e2e;
    background: #FFFFFF;
    border: 2px solid rgba(238,46,46,1);
    margin-right: 22px;
    flex-shrink: 0;
  }
  .qd{
    width: 372px;
    height: 80px;
    background: #EE2E2E;
    border: 2px solid rgba(238,46,46,1);
  }
}
.tabsBox{
  display: flex;
  margin: 40px 20px 30px;
  text-align: left;
  overflow: auto;
  .tabs_int{
    display: flex;
    align-items: center;
    height: 60px;
    line-height: 60px;
    margin-right: 20px;
    flex-shrink: 0;
    >span{
      font-size: 24px;
      display: inline-block;
      height: 40px;
      line-height: 46px;
      padding: 0 20px;
      border: 2px solid rgba(238,46,46,1);
      border-radius: 40px;
      color: #ee2e2e;
    }
  }
}
</style>
